import { render, staticRenderFns } from "./cor_bishop.vue?vue&type=template&id=aceeeaa8&scoped=true&lang=pug&"
import script from "./cor_bishop.vue?vue&type=script&lang=js&"
export * from "./cor_bishop.vue?vue&type=script&lang=js&"
import style0 from "./cor_bishop.vue?vue&type=style&index=0&id=aceeeaa8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aceeeaa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCarousel,VCarouselItem,VCol,VContainer,VImg,VRow})
